import React from 'react';
import { Check } from 'lucide-react';
import '../styles/Calculator.css';

const TIERS = [
  { min: 15000, label: 'Grande capacité', color: '#F97316' },
  { min: 6000, label: 'Moyenne capacité', color: '#0EA5E9' },
  { min: 0, label: 'Petite capacité', color: '#22C55E' }
];

const getTier = (puissance) => TIERS.find(t => puissance >= t.min);

const ProductSelector = ({ products, selectedProduct, onProductChange }) => {
  return (
    <section className="pack-picker">
      <div className="calc-title-block">
        <h3 className="calc-title">Choisissez votre pack solaire</h3>
        <p className="calc-subtitle">Sélectionnez la capacité qui correspond à vos besoins énergétiques</p>
      </div>

      <div className="pack-picker__grid">
        {products.map(product => {
          const tier = getTier(product.puissance);
          const isActive = selectedProduct.id === product.id;

          return (
            <button
              key={product.id}
              type="button"
              className={`pack-picker__tile ${isActive ? 'is-active' : ''}`}
              aria-pressed={isActive}
              title={`${product.name} · ${tier.label}`}
              onClick={() => onProductChange(product)}
            >
              <span className="pack-picker__value">
                {product.puissance.toLocaleString()}
                <small> Wh</small>
              </span>
              <span className="pack-picker__tier">
                {isActive ? (
                  <Check size={12} strokeWidth={3} className="pack-picker__check" aria-hidden="true" />
                ) : (
                  <span className="pack-picker__dot" style={{ background: tier.color }} aria-hidden="true" />
                )}
                {tier.label.split(' ')[0]}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default ProductSelector;
